import React from 'react';
import NavBarIntro from "./NavBarIntro";
import MainBody from "./MainBody";

const App =  () =>{
    return (
        <div>
            <NavBarIntro />
            <MainBody />
        </div>
    )
};

export default App;